export default {
    KEYDOWN: 'keydown',
    KEYUP: 'keyup',
    TOUCHSTART: 'touchstart',
    TOUCHEND: 'touchend'
};
